import _ from "lodash";
import { API } from "aws-amplify";
import { FETCH_BUBBLES, PUSH_NOTIFICATION, UPDATE_BUBBLES } from "./types";
import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

const apiRequestFixedParams = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const fetchChatbotBubbles = () => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GetTopBubbles",
      Skill: _.omit(state.skill, ["buildInfo"]),
      ...apiRequestFixedParams
    }
  };

  await API.post(config.AWS_API_NAME, "skills", data)
    .then(response => {
      dispatch({
        type: FETCH_BUBBLES,
        payload: response
      });
    })
    .catch(error => {
      console.error("error", error);
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Error while fetching chatbot settings!",
          type: "error"
        }
      });
    });
};

export const updateChatbotBubbles = bubbles => async (dispatch, getState) => {
  const state = getState();
  let data = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "UpdateTopBubbles",
      ...apiRequestFixedParams,
      bubbles: bubbles,
      SkillId: state.skill.ID
    }
  };

  await API.post(config.AWS_API_NAME, "skills", data)
    .then(response => {
      dispatch({
        type: UPDATE_BUBBLES,
        payload: response
      });
    })
    .catch(error => {
      console.error("error", error);
      dispatch({
        type: PUSH_NOTIFICATION,
        payload: {
          message: "Error while fetching chatbot settings!",
          type: "error"
        }
      });
    });
};
